"use client";
import * as g from "react";
import { a as Oe } from "./useAnimationsFinished-DDpUuXkZ.mjs";
import { E as ke } from "./useRenderElement-B8V3_e8R.mjs";
import { i as fe, c as De } from "./event-CXjJudzK.mjs";
import { a as x, d as Q, e as Le, c as Me, g as Ie, f as Z, h as Se } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
import { u as le, T as Ke } from "./useTimeout-BRUciAq6.mjs";
import { u as P } from "./useEventCallback-CjuAhyNz.mjs";
import { u as xe } from "./FloatingTree-vWe5pGqE.mjs";
import { c as Ye } from "./useFloatingRootContext-BSTWPoxk.mjs";
import { g as Y, f as de, j as _e, c as z, k, F as Xe, l as ge, S as Ee } from "./element-DE7VsBMX.mjs";
import { g as ee } from "./nodes-C8EyMHS3.mjs";
function Je(s, v = {}) {
  const {
    open: f,
    onOpenChange: u,
    dataRef: n
  } = s, {
    enabled: r = !0,
    event: a = "click",
    toggle: t = !0,
    ignoreMouse: l = !1,
    stickIfOpen: d = !0
  } = v, D = g.useRef(void 0), S = Oe(), _ = g.useMemo(() => ({
    onPointerDown(L) {
      D.current = L.pointerType;
    },
    onMouseDown(L) {
      const K = D.current, T = L.nativeEvent;
      if (L.button !== 0 || a === "click" || fe(K, !0) && l)
        return;
      const R = n.current.openEvent, C = R == null ? void 0 : R.type, X = !(f && t && (!(R && d) || C === "click" || C === "mousedown"));
      S.request(() => {
        u(X, T, "click");
      });
    },
    onClick(L) {
      const K = D.current;
      if (a === "mousedown" && K) {
        D.current = void 0;
        return;
      }
      if (fe(K, !0) && l)
        return;
      const T = n.current.openEvent, R = T == null ? void 0 : T.type;
      u(!(f && t && (!(T && d) || R === "click" || R === "mousedown" || R === "keydown" || R === "keyup")), L.nativeEvent, "click");
    },
    onKeyDown() {
      D.current = void 0;
    }
  }), [n, a, l, u, f, d, t, S]);
  return g.useMemo(() => r ? {
    reference: _
  } : ke, [r, _]);
}
const Ae = {
  intentional: "onClick",
  sloppy: "onPointerDown"
};
function pe(s) {
  return {
    escapeKey: typeof s == "boolean" ? s : (s == null ? void 0 : s.escapeKey) ?? !1,
    outsidePress: typeof s == "boolean" ? s : (s == null ? void 0 : s.outsidePress) ?? !0
  };
}
function $e(s, v = {}) {
  const {
    open: f,
    onOpenChange: u,
    elements: n,
    dataRef: r
  } = s, {
    enabled: a = !0,
    escapeKey: t = !0,
    outsidePress: l = !0,
    outsidePressEvent: d = "sloppy",
    referencePress: D = !1,
    referencePressEvent: S = "sloppy",
    ancestorScroll: _ = !1,
    bubbles: L,
    capture: K
  } = v, T = xe(), R = P(typeof l == "function" ? l : () => !1), C = typeof l == "function" ? R : l, X = g.useRef(!1), {
    escapeKey: N,
    outsidePress: ne
  } = pe(L), {
    escapeKey: A,
    outsidePress: E
  } = pe(K), h = g.useRef(null), F = le(), ye = le(), V = g.useRef(!1), re = g.useRef(""), q = P((e) => {
    re.current = e.pointerType;
  }), B = P(() => {
    const e = re.current, c = e === "pen" || !e ? "mouse" : e;
    return typeof d == "string" ? d : d[c];
  }), M = P((e) => {
    var o;
    if (!f || !a || !t || e.key !== "Escape" || V.current)
      return;
    const c = (o = r.current.floatingContext) == null ? void 0 : o.nodeId, p = T ? ee(T.nodesRef.current, c) : [];
    if (!N && (e.stopPropagation(), p.length > 0)) {
      let i = !0;
      if (p.forEach((y) => {
        var m;
        (m = y.context) != null && m.open && !y.context.dataRef.current.__escapeKeyBubbles && (i = !1);
      }), !i)
        return;
    }
    u(!1, De(e) ? e.nativeEvent : e, "escape-key");
  }), se = P((e) => {
    const c = B();
    return c === "intentional" && e.type !== "click" || c === "sloppy" && e.type === "click";
  }), j = P((e) => {
    var p;
    const c = () => {
      var o;
      M(e), (o = Y(e)) == null || o.removeEventListener("keydown", c);
    };
    (p = Y(e)) == null || p.addEventListener("keydown", c);
  }), b = P((e) => {
    var ae;
    if (se(e))
      return;
    const c = r.current.insideReactTree;
    r.current.insideReactTree = !1;
    const p = X.current;
    if (X.current = !1, B() === "intentional" && p || c || typeof C == "function" && !C(e))
      return;
    const o = Y(e), i = `[${Ye("inert")}]`, y = de(n.floating).querySelectorAll(i);
    let m = x(o) ? o : null;
    for (; m && !Q(m); ) {
      const w = Le(m);
      if (Q(w) || !x(w))
        break;
      m = w;
    }
    if (y.length && x(o) && !_e(o) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !z(o, n.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(y).every((w) => !z(m, w)))
      return;
    if (Me(o)) {
      const w = Q(o), O = Ie(o), U = /auto|scroll/, Te = w || U.test(O.overflowX), we = w || U.test(O.overflowY), Pe = Te && o.clientWidth > 0 && o.scrollWidth > o.clientWidth, ve = we && o.clientHeight > 0 && o.scrollHeight > o.clientHeight, Re = O.direction === "rtl", Ce = ve && (Re ? e.offsetX <= o.offsetWidth - o.clientWidth : e.offsetX > o.clientWidth), be = Pe && e.offsetY > o.clientHeight;
      if (Ce || be)
        return;
    }
    const W = (ae = r.current.floatingContext) == null ? void 0 : ae.nodeId, he = T && ee(T.nodesRef.current, W).some((w) => {
      var O;
      return k(e, (O = w.context) == null ? void 0 : O.elements.floating);
    });
    if (k(e, n.floating) || k(e, n.domReference) || he)
      return;
    const ue = T ? ee(T.nodesRef.current, W) : [];
    if (ue.length > 0) {
      let w = !0;
      if (ue.forEach((O) => {
        var U;
        (U = O.context) != null && U.open && !O.context.dataRef.current.__outsidePressBubbles && (w = !1);
      }), !w)
        return;
    }
    u(!1, e, "outside-press");
  }), oe = P((e) => {
    if (!(B() !== "sloppy" || !f || !a || k(e, n.floating) || k(e, n.domReference))) {
      if (e.pointerType === "touch") {
        h.current = {
          startTime: Date.now(),
          startX: e.clientX,
          startY: e.clientY,
          dismissOnPointerUp: !1,
          dismissOnMouseDown: !0
        }, F.start(1e3, () => {
          h.current && (h.current.dismissOnPointerUp = !1, h.current.dismissOnMouseDown = !1);
        });
        return;
      }
      b(e);
    }
  }), I = P((e) => {
    var p;
    if (se(e) || (F.clear(), e.type === "mousedown" && h.current && !h.current.dismissOnMouseDown))
      return;
    const c = () => {
      var o;
      e.type === "pointerdown" ? oe(e) : b(e), (o = Y(e)) == null || o.removeEventListener(e.type, c);
    };
    (p = Y(e)) == null || p.addEventListener(e.type, c);
  }), G = P((e) => {
    if (B() !== "sloppy" || e.pointerType !== "touch" || !h.current || k(e, n.floating) || k(e, n.domReference))
      return;
    const c = Math.abs(e.clientX - h.current.startX), p = Math.abs(e.clientY - h.current.startY), o = Math.sqrt(c * c + p * p);
    o > 5 && (h.current.dismissOnPointerUp = !0), o > 10 && (b(e), F.clear(), h.current = null);
  }), J = P((e) => {
    B() !== "sloppy" || e.pointerType !== "touch" || !h.current || k(e, n.floating) || k(e, n.domReference) || (h.current.dismissOnPointerUp && b(e), F.clear(), h.current = null);
  });
  g.useEffect(() => {
    if (!f || !a)
      return;
    r.current.__escapeKeyBubbles = N, r.current.__outsidePressBubbles = ne;
    const e = new Ke();
    function c(m) {
      u(!1, m, "ancestor-scroll");
    }
    function p() {
      e.clear(), V.current = !0;
    }
    function o() {
      e.start(
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        Se() ? 5 : 0,
        () => {
          V.current = !1;
        }
      );
    }
    const i = de(n.floating);
    i.addEventListener("pointerdown", q, !0), t && (i.addEventListener("keydown", A ? j : M, A), i.addEventListener("compositionstart", p), i.addEventListener("compositionend", o)), C && (i.addEventListener("click", E ? I : b, E), i.addEventListener("pointerdown", E ? I : b, E), i.addEventListener("pointermove", G, E), i.addEventListener("pointerup", J, E), i.addEventListener("mousedown", I, E));
    let y = [];
    return _ && (x(n.domReference) && (y = Z(n.domReference)), x(n.floating) && (y = y.concat(Z(n.floating))), !x(n.reference) && n.reference && n.reference.contextElement && (y = y.concat(Z(n.reference.contextElement)))), y = y.filter((m) => {
      var W;
      return m !== ((W = i.defaultView) == null ? void 0 : W.visualViewport);
    }), y.forEach((m) => {
      m.addEventListener("scroll", c, {
        passive: !0
      });
    }), () => {
      i.removeEventListener("pointerdown", q, !0), t && (i.removeEventListener("keydown", A ? j : M, A), i.removeEventListener("compositionstart", p), i.removeEventListener("compositionend", o)), C && (i.removeEventListener("click", E ? I : b, E), i.removeEventListener("pointerdown", E ? I : b, E), i.removeEventListener("pointermove", G, E), i.removeEventListener("pointerup", J, E), i.removeEventListener("mousedown", I, E)), y.forEach((m) => {
        m.removeEventListener("scroll", c);
      }), e.clear();
    };
  }, [r, n, t, C, d, f, u, _, a, N, ne, M, A, j, b, E, I, oe, G, J, q]), g.useEffect(() => {
    r.current.insideReactTree = !1;
  }, [r, C]);
  const ie = g.useMemo(() => ({
    onKeyDown: M,
    ...D && {
      [Ae[S]]: (e) => {
        u(!1, e.nativeEvent, "reference-press");
      },
      ...S !== "intentional" && {
        onClick(e) {
          u(!1, e.nativeEvent, "reference-press");
        }
      }
    }
  }), [M, u, D, S]), $ = P((e) => {
    const c = Y(e.nativeEvent);
    z(n.floating, c) && (X.current = !0);
  }), H = P(() => {
    r.current.insideReactTree = !0, ye.start(0, () => {
      r.current.insideReactTree = !1;
    });
  }), ce = g.useMemo(() => ({
    onKeyDown: M,
    onMouseDown: $,
    onMouseUp: $,
    onPointerDownCapture: H,
    onMouseDownCapture: H,
    onClickCapture: H
  }), [M, $, H]);
  return g.useMemo(() => a ? {
    reference: ie,
    floating: ce
  } : {}, [a, ie, ce]);
}
function Qe(s = []) {
  const v = s.map((t) => t == null ? void 0 : t.reference), f = s.map((t) => t == null ? void 0 : t.floating), u = s.map((t) => t == null ? void 0 : t.item), n = g.useCallback(
    (t) => te(t, s, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    v
  ), r = g.useCallback(
    (t) => te(t, s, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    f
  ), a = g.useCallback(
    (t) => te(t, s, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    u
  );
  return g.useMemo(() => ({
    getReferenceProps: n,
    getFloatingProps: r,
    getItemProps: a
  }), [n, r, a]);
}
function te(s, v, f) {
  var a;
  const u = /* @__PURE__ */ new Map(), n = f === "item", r = {};
  f === "floating" && (r.tabIndex = -1, r[Xe] = "");
  for (const t in s)
    n && s && (t === ge || t === Ee) || (r[t] = s[t]);
  for (let t = 0; t < v.length; t += 1) {
    let l;
    const d = (a = v[t]) == null ? void 0 : a[f];
    typeof d == "function" ? l = s ? d(s) : null : l = d, l && me(r, l, n, u);
  }
  return me(r, s, n, u), r;
}
function me(s, v, f, u) {
  var n;
  for (const r in v) {
    const a = v[r];
    f && (r === ge || r === Ee) || (r.startsWith("on") ? (u.has(r) || u.set(r, []), typeof a == "function" && ((n = u.get(r)) == null || n.push(a), s[r] = (...t) => {
      var l;
      return (l = u.get(r)) == null ? void 0 : l.map((d) => d(...t)).find((d) => d !== void 0);
    })) : s[r] = a);
  }
}
function Ze(s) {
  if (s)
    return {
      // Identical mappings
      "focus-out": "focus-out",
      "escape-key": "escape-key",
      "outside-press": "outside-press",
      "list-navigation": "list-navigation",
      // New mappings
      click: "trigger-press",
      hover: "trigger-hover",
      focus: "trigger-focus",
      "reference-press": "trigger-press",
      "safe-polygon": "trigger-hover",
      "ancestor-scroll": void 0
      // Not supported
    }[s];
}
export {
  $e as a,
  Qe as b,
  Ze as t,
  Je as u
};
